import { loadStripe, type Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY)
  }
  return stripePromise
}

export const createCardElement = (stripe: Stripe) => {
  const card = stripe.elements().create('card', {
    classes: {
      base: 'pl-4 py-[14px] pr-3 rounded-[8px] bg-white border border-[#CFD5E1]',
      invalid: 'border-red-500',
    },
    style: {
      base: {
        color: '#292C30',
        fontSize: '14px',
        lineHeight: '18px',
      },
    },
  })

  return card
}
